//#region imports
import React, { useState } from 'react';

// tremor
import { TabList, Tab } from '@tremor/react';

// icons
import { MdFlight } from 'react-icons/md';
import { FaWalking } from 'react-icons/fa';

// styling
import { Colors, Spacing } from '_styles';

// components
import FlightSearch from './flight-search';
import PassengerSearch from './passenger-search';

//#endregion

const TimelineSearch = (props) => {

    // tab state
    const [activeTab, setActiveTab] = useState("passengers");

    return (
        <div style={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: 'white',
        }}>
            {/* Tab Selector */}
            <TabList
                defaultValue="passengers"
                onValueChange={(value) => setActiveTab(value)}
                style={{ marginBottom: Spacing.SCALE_8 }}
            >
                <Tab value="passengers" text="Passenger Search" />
                <Tab value="flights" text="Flight Search" />
            </TabList>

            {/* Tab Content */}
            <div style={{ flex: 1, minHeight: 0 }} className='mt-3'>
                {activeTab === "passengers" && (
                    <PassengerSearch onPassengerSelect={props.onPassengerSelect} />
                )}

                {activeTab === "flights" && (
                    <FlightSearch onFlightSelect={props.onFlightSelect} />
                )}
            </div>
        </div>
    );
};

export default TimelineSearch;
